require.config({urlArgs: window.cacheId});
require(["./LoadConfig"], loadConfig => loadConfig.default(['./config'], main ));

//document.querySelector('main').classList.add('is-loading');
function main(){
  require(['./ModuleCardProduct'], (CardProduct) => {

    Array.prototype.slice.call(
      document.querySelectorAll('.card-product')
    ).forEach(x => new CardProduct.default(x));
  });
}